import React, { useEffect, useState, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import {
  Form,
  Input,
  Row,
  Spin,
  Col,
  Select,
  Modal,
  Typography,
  Button,
  DatePicker,
  notification,
  Alert,
} from "antd";
import {
  AudioOutlined,
  CameraOutlined,
  CameraTwoTone,
  LoadingOutlined,
  PictureOutlined,
  PictureTwoTone,
  RotateLeftOutlined,
  RotateRightOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
} from "@ant-design/icons";
import moment from "moment";
import Cropper from "react-cropper";
import Webcam from "react-webcam";
import Tesseract from "tesseract.js";
import "cropperjs/dist/cropper.css";
import ProductApi from "../../Apis/ProductApi";
import StockApi from "../../Apis/StockApi";
import dayjs from "dayjs";
import AllergenStock from "../../DropDowns/Stock/AllergenStock";
import QuestionnairesApi from "../../Apis/QuestionnairesApi";
import IngredientsApi from "../../Apis/IngredientsApi";
import AllergensApi from "../../Apis/AllergensApi";
import ShelfLifeApi from "../../Apis/ShelfLifeApi";
import CoolingShelfApi from "../../Apis/CoolingShelfApi";
import StorageSuggestionApi from "../../Apis/StorageSuggestionApi";
import StorageListApi from "../../Apis/StorageListApi";
import DateInputMask from "../Date/DateInputMask"

const { Title } = Typography;

function AddStock({ visible, onClose, ProductDetails, onContinue  }) {
  const [barcodeError, setBarcodeError] = useState(null);
  const [formAdd] = Form.useForm();
  const [form] = Form.useForm();
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const CURRENCY = decodedToken.currency === "USD" ? "$" : "€";
  const cropperRef = useRef(null);
  const [src, setSrc] = useState(null);
  const [selectedOption, setSelectedOption] = useState("PName");
  const [rotation, setRotation] = useState(0);
  const [Allergens, setAllergens] = React.useState([]);
  const [ShelfResponse, setShelfResponse] = useState(null);
  const [coolingShelfResponse, setCoolingShelfResponse] = useState(null);
  const [StorageSuggestionResponse, setStorageSuggestionResponse] = useState(null);
  const [Ingredient, setIngredient] = useState("");
  const [SelectPro, setSelectPro] = React.useState(null);
  const [storagesLoading, setStoragesLoading] = useState(false);
  const [barcodeScanning, setBarcodeScanning] = useState(false);
  const [barcodeType, setBarcodeType] = useState(null); // 'gs1' or 'standard'
  const [gtin, setGtin] = useState(null);
  const inputRef = useRef(null);

  useEffect(() => {
    if(visible) {
        setTimeout(() => {
            inputRef.current?.focus();
        }, 100);
      }
}, [visible]);

  // Add this useEffect to handle GS1 batch code updates
useEffect(() => {
  // Check if we have a GS1 barcode and the batch code is set
  if (barcodeType === 'gs1') {
    const currentBatchCode = formAdd.getFieldValue('batchCode');
    if (currentBatchCode) {
      // Check if it already has a date appended
      const parts = currentBatchCode.split('_');
      if (parts.length === 1) {
        // No date appended, add it
        const today = dayjs().format('YYYYMMDD');
        const updatedBatchCode = `${currentBatchCode}_${today}`;
        formAdd.setFieldsValue({
          batchCode: updatedBatchCode
        });
      } else if (parts.length === 2 && parts[1].length === 8 && !isNaN(parts[1])) {
        // Already has a date, update it to today's date
        const today = dayjs().format('YYYYMMDD');
        if (parts[1] !== today) {
          const updatedBatchCode = `${parts[0]}_${today}`;
          formAdd.setFieldsValue({
            batchCode: updatedBatchCode
          });
        }
      }
    }
  }
}, [barcodeType, formAdd]);

  const handleChangeProduct = (value) => {
    ProductApi.SingleProducts(value)
      .then((response) => {
        setSelectPro(response?.payload);

        const fullBarcode = response?.payload?.productCode || '';
        const extractedBarcode = fullBarcode.includes('#') ? fullBarcode.split('#')[1] : fullBarcode;

        formAdd.setFieldsValue({
          barcode: extractedBarcode,
          unit: response?.payload?.unitUomOne,
          institutionId: response?.payload?.institutionDTO?.id,
          Allergen: response?.payload?.allergens?.map(item => item.id),
          storageId: response?.payload?.storageDTO?.id,
        });
      })
      .catch((err) => {
        console.log(err);
        notification.error({
          message: "Error",
          description: "Failed to load product details",
        });
      });
  };

  const getAllergens = useCallback(() => {
    AllergensApi.ListAllergensApi(0,100)
      .then((response) => {
        setAllergens(response?.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const getShelfLifes = useCallback(() => {
    if (SelectPro?.shelfLifeDTO?.id) {
      ShelfLifeApi.SingleShelfLife(SelectPro?.shelfLifeDTO?.id)
        .then((response) => {
          setShelfResponse(response.payload);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [SelectPro?.shelfLifeDTO?.id]);

  const getCoolingShelfLifes = useCallback(() => {
    if (SelectPro?.coolingShelfLifeDTO?.id) {
      CoolingShelfApi.SingleCoolingProcess(SelectPro?.coolingShelfLifeDTO?.id)
        .then((response) => {
          setCoolingShelfResponse(response.payload);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [SelectPro?.coolingShelfLifeDTO?.id]);

  const getStorage = useCallback(() => {
    if (SelectPro?.storageSuggestionDTO?.id) {
      StorageSuggestionApi.Singlestorage(SelectPro?.storageSuggestionDTO?.id)
        .then((response) => {
          setStorageSuggestionResponse(response.payload);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [SelectPro?.storageSuggestionDTO?.id]);

  const getIngredient = useCallback(() => {
    if (SelectPro?.id) {
      IngredientsApi.SingleProducts(SelectPro?.id)
        .then((response) => {
          setIngredient(response.payload);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [SelectPro?.id]);

  const onSelectFile = (e) => {
    setisCameraOn(false);
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.onload = () => setSrc(reader.result);
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const handleRotate = () => {
    setRotation((prevRotation) => (prevRotation + 90) % 360);
  };

  const handleRightRotate = () => {
    setRotation((prevRotation) => (prevRotation + -90) % 360);
  };

  const [selectedPName, setPName] = useState("");
  const [selectedBarCode, setBarCode] = useState("");
  const [selectedOUBD, setOUBD] = useState("");
  const [loadings, setLoadings] = useState(false);

  const [Products, setProducts] = React.useState([]);
  const [loading, setLoading] = useState(false);
  const [TotalPageNew, setTotalPageNew] = useState(null);
  const [page, setPage] = useState(0);
  const [storages, setStorages] = React.useState([]);

  const fetchDepartments = async () => {
    try {
      setLoading(true);
      ProductApi.Listproducts(page, 500)
        .then((response) => {
          setTotalPageNew(response.totalPages);
          setProducts(prevDepartments => [...prevDepartments, ...response?.payloadDto]);
          setPage(prevPage => prevPage + 1);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    } catch (error) {
      console.error('Error fetching departments:', error);
      setLoading(false);
    }
  };

  const handleScroll = (e) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    const nearBottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 1;
    if (bottom || nearBottom) {
      if (TotalPageNew > page) {
        fetchDepartments();
      }
    }
  };

  const getStorages = useCallback(() => {
    setStoragesLoading(true);
    // Fetch all storages at once to ensure we have the complete list
    StorageListApi.ListStorage(0, 1000)
      .then((response) => {
        setStorages(response?.payloadDto || []);
      })
      .catch((err) => {
        console.log(err);
        notification.error({
          message: "Error",
          description: "Failed to load storage locations",
        });
      })
      .finally(() => {
        setStoragesLoading(false);
      });
  }, []);

  useEffect(() => {
    getAllergens();
    getStorages();
    if (TotalPageNew >= page) {
      fetchDepartments();
    }
  }, [getAllergens, getStorages]);

  // Separate effects for product-dependent data
  useEffect(() => {
    if (SelectPro) {
      getShelfLifes();
      getCoolingShelfLifes();
      getStorage();
      getIngredient();
    }
  }, [SelectPro, getShelfLifes, getCoolingShelfLifes, getStorage, getIngredient]);

  // Effect to set storageId when SelectPro changes and storages are loaded
  useEffect(() => {
    if (SelectPro?.storageDTO?.id && storages.length > 0 && visible) {
      setTimeout(() => {
        formAdd.setFieldsValue({
          storageId: SelectPro.storageDTO.id
        });
      }, 100);
    }
  }, [SelectPro?.storageDTO?.id, storages, visible, formAdd]);

  const handleInputChangeProduct = (value2) => {
    let filderData = window.btoa("componentCode=PRODUCT&productName=%" + value2 + "%");
    QuestionnairesApi.FilterQuestionsetNext(filderData, 0, 10)
      .then((response) => {
        setProducts(response.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const productUpdate = (data) => {
    const SelectDate = dayjs(SelectPro.createDate).format("DD/MM/YYYY");
    const expiryDate = dayjs(SelectPro.expiryDate).format("DD/MM/YYYY");
    const allergenNames = Allergens
      .filter(item => SelectPro?.Allergen?.includes(item.id))
      .map(item => item.id);

    const OUBD = dayjs(SelectPro.OUBD).format("DD/MM/YYYY");
    let formData = JSON.stringify({
      institutionId: SelectPro.institutionId,
      productCreateDate: convertToUnixTimestamp(SelectDate),
      expiryDate: convertToUnixTimestamp(expiryDate),
      productName: SelectPro.productName,
      productCode: SelectPro.productCode,
      currency: CURRENCY,
      unitUomOne: SelectPro.unit,
      unitUomTwo: SelectPro.unit2,
      unitUomThree: SelectPro.unit3,
      unitOfMeasurement1: SelectPro.unitOfMeasurement1,
      unitOfMeasurement2: SelectPro.unitOfMeasurement2,
      unitOfMeasurement3: SelectPro.unitOfMeasurement3,
      costPriceUoM1: SelectPro.costPriceUoM1,
      costPriceUoM2: SelectPro.costPriceUoM2,
      costPriceUoM3: SelectPro.costPriceUoM3,
      sellingPriceUoM1: 0.00,
      sellingPriceUoM2: 0.00,
      sellingPriceUoM3: 0.00,
      department: "",
      allergen: SelectPro?.Allergen?.join(','),
      supplierDTO: SelectPro.supplierId?.map((number) => ({ id: number })),
      allergens: data.Allergen?.map((number) => ({ id: number })),
      openUBD: convertToUnixTimestamp(OUBD),
      shelfLifeDTO: (SelectPro?.ShelfLifeID) ? {
        id: SelectPro?.ShelfLifeID,
        period: ShelfResponse?.period,
        periodType: ShelfResponse?.periodType,
        tenantDTO: {
          id: ShelfResponse?.tenantDTO?.id,
          tenantApiKey: ShelfResponse?.tenantDTO?.tenantApiKey,
        },
      } : null,
      allergensDTO: {
        id: SelectPro?.Allergen?.[0],
      },
      coolingShelfLifeDTO: (SelectPro?.CoolingShelfLifeID) ? {
        id: SelectPro?.CoolingShelfLifeID,
        period: coolingShelfResponse?.period,
        periodType: coolingShelfResponse?.periodType,
        temperatureInCelsius: coolingShelfResponse?.temperatureInCelsius,
        tenantDTO: {
          id: coolingShelfResponse?.tenantDTO?.id,
          tenantApiKey: coolingShelfResponse?.tenantDTO?.tenantApiKey,
        },
      } : null,
      institutionDTO: {
        id: SelectPro.institutionId,
      },
      storageSuggestionDTO: {
        id: SelectPro?.StorageID,
        description: StorageSuggestionResponse?.description,
        name: StorageSuggestionResponse?.name,
        tenantDTO: {
          id: StorageSuggestionResponse?.tenantDTO?.id,
          tenantApiKey: StorageSuggestionResponse?.tenantDTO?.tenantApiKey,
        },
      },
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
    });

    ProductApi.PutProduct(SelectPro?.id, formData)
      .then((response) => {
        let form2 = JSON.stringify({
          name: SelectPro.productName,
          ingredientsStatus: "OPENED",
          batchCode: SelectPro.productCode,
          allergensDTO: allergenNames?.map((number) => ({ id: number })),
          productDTO: {
            id: response?.payload?.id,
          },
          tenantDTO: {
            id: decodedToken?.tenantId,
            tenantApiKey: decodedToken?.tenantApiKey,
          },
          institutionDTO: {
            id: SelectPro?.institutionId,
          },
        });
        IngredientsApi.PutIngredients(Ingredient?.id, form2)
          .then((response) => {
            notification.open({
              message: <span style={{ fontWeight: "bold" }}>Successfully</span>,
              description: "Updated Successfully",
              closeIcon: false,
              duration: 3,
              style: {
                backgroundColor: "#b3ffb3",
                color: "green",
              },
            });

            setTimeout(() => {
              window.location.reload();
            }, 500);
          })
          .catch((err) => {
            if (err.apiError?.status) {
              notification.open({
                message: <span style={{ fontWeight: "bold" }}>Error</span>,
                description: err.apiError.message,
                closeIcon: false,
                duration: 3,
                style: {
                  backgroundColor: "#fff2f0",
                  color: "red",
                },
              });
            }
          });
      })
      .catch((err) => {
        console.log(err);
        if (err.apiError?.status) {
          notification.open({
            message: (
              <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
            ),
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };


    // Add this helper function at the top of your component, before handleSubmit
  const generateBatchCode = (productBarcode, gtin, date) => {
    // Format date as YYYYMMDD
    const formattedDate = dayjs().format('YYYYMMDD');
    
    // Use GTIN if available, otherwise use product barcode
    const code = gtin || productBarcode;
    
    // If no code is available, use a default
    if (!code) {
      return `BATCH_${formattedDate}`;
    }
    

  if (code.includes('_')) {
    // If it already has an underscore, replace the date part
    const parts = code.split('_');
    if (parts.length === 2 && parts[1].length === 8 && !isNaN(parts[1])) {
      // It already has a date format, update it
      return `${parts[0]}_${formattedDate}`;
    }
    // Otherwise keep the original format
    return code;
  }

    return `${code}_${formattedDate}`;
  };


  const handleSubmit = (data) => {

    const uom1 = data.unitOfMeasurement1;
  const uom2 = data.unitOfMeasurement2;

  // Both cannot be empty
  if (
    (uom1 === undefined || uom1 === "" || uom1 === null) &&
    (uom2 === undefined || uom2 === "" || uom2 === null)
  ) {
    notification.error({
      message: "Validation Error",
      description: "Please enter a value for UoM1 or UoM2.",
    });
    return;
  }

  // If UoM1 empty and UoM2 has value
  if (
    (uom1 === undefined || uom1 === "" || uom1 === null) &&
    uom2 !== undefined &&
    uom2 !== "" &&
    uom2 !== null
  ) {
    data.unitOfMeasurement1 = 0;
  }

  
    if (!SelectPro) {
      notification.error({
        message: "Error",
        description: "Please select a product first",
      });
      return;
    }

      // Check if batchCode is empty and generate one if needed
  let batchCode = data.batchCode;
  
  if (!batchCode || batchCode.trim() === '') {
    const productBarcode = SelectPro?.productCode || '';
    const gtinValue = gtin || '';
    const code = gtinValue || productBarcode;
    batchCode = generateBatchCode(code, gtinValue, data.OUBD);
    
    // Update the form field with the generated batch code
    formAdd.setFieldsValue({
      batchCode: batchCode
    });
    
    // Update data object with the generated batch code
    data.batchCode = batchCode;
  }
  
    const SelectDate = dayjs(data.OUBD).format("DD/MM/YYYY");
    const expiryDateN = dayjs(data.OUBD).format("DD/MM/YYYY");

    const uom1Value = parseFloat(data.unitOfMeasurement1 || 0);
    const uom2Value = parseFloat(data.unitOfMeasurement2 || 0);

    let formData = JSON.stringify({
      unitOfMeasurement1:
        (uom1Value * parseFloat(SelectPro?.unitOfMeasurement2 || 1)) +
        uom2Value,
      invoiceNumber: data.invoiceNumber,
      openUBD: null,
      expiryDate: convertToUnixTimestamp(SelectDate),
      batchCode: data.batchCode,
      allergensDTO: data.Allergen?.map((number) => ({ id: number })) || [],
      unit: SelectPro?.unitUomTwo,
      productDTO: {
        id: data.productId,
      },
      productDTOs: [{
        id: data.productId,
      }],
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
      storageId: data.storageId,
    });

    StockApi.CreateStock(formData)
      .then((response) => {
        if (response?.payload?.stockAlreadyAvailable === true) {
          let formData = JSON.stringify({
            unitOfMeasurement1: data.unitOfMeasurement1,
            invoiceNumber: data.invoiceNumber,
            version: response?.payload?.version,
            unitOfMeasurement2: data.unitOfMeasurement2,
            openUBD: convertToUnixTimestamp(SelectDate),
            expiryDate: convertToUnixTimestamp(expiryDateN),
            batchCode: data.batchCode,
            allergensDTO: data.Allergen?.map((number) => ({ id: number })) || [],
            unit: data?.unit,
            productDTO: {
              id: data.productId,
            },
            productDTOs: [{
              id: data.productId,
            }],
            tenantDTO: {
              id: decodedToken?.tenantId,
              tenantApiKey: decodedToken?.tenantApiKey,
            },
            storageId: data.storageId,
          });
          StockApi.UpdateStock(response?.payload?.id, formData)
            .then((response) => {
              notification.open({
                message: <span style={{ fontWeight: "bold" }}>Created</span>,
                description: "Created Successfully",
                closeIcon: false,
                duration: 3,
                style: {
                  backgroundColor: "#b3ffb3",
                  color: "green",
                },
              });

               if (shouldContinue) {
                // Reset form and reopen
                resetAndContinue();
              } else {
                setTimeout(() => {
                  window.location.reload();
                }, 500);
              }
            })

            .catch((err) => {
              console.log(err);
              if (err.apiError?.status) {
                notification.open({
                  message: (
                    <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
                  ),
                  description: err.apiError.message,
                  closeIcon: false,
                  duration: 3,
                  style: {
                    backgroundColor: "#fff2f0",
                    color: "red",
                  },
                });
              }
                
              setShouldContinue(false);

            });
        } else {
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Created</span>,
            description: "Created Successfully",
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#b3ffb3",
              color: "green",
            },
          });

          // Check if we should continue
          if (shouldContinue) {
            // Reset form and reopen
            resetAndContinue();
          } else {
            setTimeout(() => {
              window.location.reload();
            }, 500);
          }
        }
      })

      .catch((err) => {
        console.log(err);
        if (err.apiError?.status) {
          notification.open({
            message: (
              <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
            ),
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }

        setShouldContinue(false);

      });
  };

  function convertToUnixTimestamp(dateString) {
    if (!dateString) return null;
    const parts = dateString.split("/");
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1;
    const year = parseInt(parts[2], 10);

    const unixTimestamp = Date.UTC(year, month, day);
    return unixTimestamp;
  }

  const handleCancel = () => {
    formAdd.resetFields();
    setSelectPro(null);
    setBarcodeError(null);
    setGtin(null); 
    onClose();
  };

   // Add state for continue flag
    const [shouldContinue, setShouldContinue] = useState(false);

    // Function to reset and continue
    const resetAndContinue = () => {
      // Reset the form
      formAdd.resetFields();
      setSelectPro(null);
      setBarcodeError(null);
      setBarcodeScanning(false);
      setShouldContinue(false);
      
      // Call onContinue to reopen the modal
      if (onContinue) {
        onContinue();
      }
    };

    const handleContinue = () => {
      setShouldContinue(true);

       const batchCode = formAdd.getFieldValue('batchCode');
    if (!batchCode || batchCode.trim() === '') {
      const productBarcode = SelectPro?.productCode || '';
      const gtinValue = gtin || '';
      
      const code = gtinValue || productBarcode;
      
      const generatedCode = generateBatchCode(code, gtinValue, dayjs());
      
      formAdd.setFieldsValue({
        batchCode: generatedCode
      });
    }
      formAdd.submit();
    };
    

  const [isModalproduct, setIsModalProduct] = useState(false);
  const webcamRef = useRef(null);
  const [isCameraOn, setisCameraOn] = useState(true);

  const captureImage = () => {
    const video = webcamRef?.current?.video;
    if (video) {
      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const context = canvas.getContext("2d");
      context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
      const dataURL = canvas.toDataURL("image/jpeg");
      setSrc(dataURL);
      setisCameraOn(false);
    }
  };

  const CameraOn = () => {
    setSrc(null);
    setisCameraOn(true);
  };

  const showModal = () => {
    startWebcamStream();
    setIsModalProduct(true);
  };

  const startWebcamStream = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });

      if (webcamRef.current) {
        webcamRef.current.video.srcObject = stream;
      }
    } catch (error) {
      console.error("Error starting webcam stream:", error);
    }
  };

  const SaveAddForm = () => {
    setIsModalProduct(false);
    formAdd.setFieldsValue({
      productId: selectedPName,
      batchCode: selectedBarCode,
      OUBD: selectedOUBD,
    });
  };

  const stopWebcamStream = () => {
    const webcamVideo = webcamRef?.current?.video;
    if (webcamVideo && webcamVideo.srcObject) {
      webcamVideo.srcObject.getTracks().forEach((track) => track.stop());
    }
  };

  const performOCR = async () => {
    setLoadings(true);
    if (!cropperRef.current) {
      setLoadings(false);
      return;
    }
    if (selectedOption) {
      const croppedCanvas = cropperRef.current.cropper.getCroppedCanvas();
      const croppedImageBase64 = croppedCanvas.toDataURL("image/jpeg");
      try {
        const tesseractResult = await Tesseract.recognize(
          croppedImageBase64,
          "eng"
        );
        if (selectedOption === "PName") {
          setPName(tesseractResult.data.text);
          form.setFieldsValue({
            ProductName: tesseractResult.data.text,
          });
        } else if (selectedOption === "BarCode") {
          setBarCode(tesseractResult.data.text);
          form.setFieldsValue({
            BarCode: tesseractResult.data.text,
          });
        }
        else if (selectedOption === "OUBD") {
          const defaultDate = moment(tesseractResult.data.text, "DD MMM YYYY");
          setOUBD(defaultDate);
          form.setFieldsValue({
            OCROUBD: defaultDate,
          });
        }
        setLoadings(false);
      } catch (error) {
        console.error("OCR Error:", error);
        setLoadings(false);
        notification.error({
          message: "OCR Error",
          description: "Failed to recognize text. Please try again.",
        });
      }
    } else {
      setLoadings(false);
      notification.open({
        message: <span style={{ fontWeight: "bold" }}>Error</span>,
        description: "Select Field",
        closeIcon: false,
        duration: 3,
        style: {
          backgroundColor: "#fff2f0",
          color: "red",
        },
      });
    }
  };

  const handleCancelProduct = () => {
    stopWebcamStream();
    setSrc(null);
    setisCameraOn(true);
    form.resetFields();
    setIsModalProduct(false);
  };

  const handleOk = () => {
    setIsModalProduct(false);
  };

  const [zoom, setZoom] = useState(1);

  const handleZoomIn = () => {
    setZoom(zoom + 0.1);
  };

  const handleZoomOut = () => {
    setZoom(zoom - 0.1);
  };

  const [isRecording, setIsRecording] = useState(false);
  const [isRecordingproductCode, setIsRecordingproductCode] = useState(false);

  const startRecording = (fieldN) => {
    const recognition = new window.webkitSpeechRecognition();
    recognition.lang = 'en-US';

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      let fieldName = fieldN;

      formAdd.setFieldsValue({
        [fieldName]: transcript,
      });
    };

    recognition.start();
    if (fieldN === 'batchCode') {
      setIsRecordingproductCode(true);
    } else if (fieldN === 'productName') {
      setIsRecording(true);
    }
  };

  const stopRecording = () => {
    setIsRecording(false);
    setIsRecordingproductCode(false);
  };

  const currentDateNew = moment().startOf('day');

  const disableDate = current => {
    return current && current < currentDateNew;
  }

  const handleInputKeyDown = (event) => {
    if (event.key === '-') {
      event.preventDefault();
    }
  };

  // Fixed parseGS1Barcode function
const parseGS1Barcode = (barcode) => {
  // Check if barcode starts with '01' (GS1 format)
  if (barcode.startsWith('01')) {
    try {
      let index = 0;
      const result = {
        gtin: null,
        date: null,
        batch: null,
        rawBarcode: barcode
      };

      console.log('Parsing GS1 barcode:', barcode);
      console.log('Barcode length:', barcode.length);

      // Parse sequentially through the barcode
      while (index < barcode.length) {
        // Get the next 2 characters as AI
        const ai = barcode.substring(index, index + 2);
        console.log(`AI at index ${index}: ${ai}`);
        index += 2;

        if (ai === '01') {
          // GTIN - 14 digits
          if (index + 14 <= barcode.length) {
            result.gtin = barcode.substring(index, index + 14);
            console.log('GTIN:', result.gtin);
            index += 14;
          } else {
            console.log('Not enough characters for GTIN');
            break;
          }
        } else if (ai === '15' || ai === '17') {
          // Date - 6 digits (YYMMDD)
          if (index + 6 <= barcode.length) {
            const dateStr = barcode.substring(index, index + 6);
            console.log('Date string:', dateStr);
            // Parse YYMMDD
            const year = parseInt(dateStr.substring(0, 2)) + 2000;
            const month = parseInt(dateStr.substring(2, 4)) - 1;
            const day = parseInt(dateStr.substring(4, 6));
            result.date = new Date(year, month, day);
            console.log('Parsed date:', result.date);
            index += 6;
          } else {
            console.log('Not enough characters for date');
            break;
          }
        } else if (ai === '10') {
          // Batch/Lot - variable length, take remaining characters
          result.batch = barcode.substring(index);
          console.log('Batch/Lot:', result.batch);
          index = barcode.length; // End parsing
        } else {
          // Unknown AI - this might be part of the batch
          console.log('Unknown AI:', ai, 'treating rest as batch');
          result.batch = barcode.substring(index - 2);
          index = barcode.length;
        }
      }

      console.log('Final parsed result:', result);
      return result;
    } catch (error) {
      console.error('Error parsing GS1 barcode:', error);
      return null;
    }
  }
  return null;
};

  // FIXED: Improved barcode scan handler
  const handleBarcodeScan = async (barcode, e) => {
    if (e) { 
      e.preventDefault();
      e.stopPropagation();
    }

     // Prevent duplicate scans
    if (barcodeScanning) return;

    // Clean barcode
    const cleanBarcode = barcode?.trim();

    if (!cleanBarcode) {
      setBarcodeError("Please enter a valid barcode");
      return;
    }
  
    setBarcodeScanning(true);
    setBarcodeError(null);


     try {
    // First, check if it's a GS1 barcode and extract data
    const gs1Data = parseGS1Barcode(cleanBarcode);
    
    if (gs1Data) {
      console.log('GS1 Barcode detected:', gs1Data);
      setBarcodeType('gs1');
      
      // Auto-populate batch code and OUBD from GS1 data
      const formValues = {};
      
      if (gs1Data.gtin) {
        formValues.gtin = gs1Data.gtin;
        setGtin(gs1Data.gtin); // Set GTIN state
        console.log('Setting GTIN to:', gs1Data.gtin);
      }
      
      if (gs1Data.batch) {
        const batchCode = gs1Data.batch;
        const today = dayjs().format('YYYYMMDD');
        formValues.batchCode = `${batchCode}_${today}`;
      }
      
      if (gs1Data.date) {
        // Convert date to dayjs object for DatePicker
        formValues.OUBD = dayjs(gs1Data.date);
        console.log('Setting OUBD to:', dayjs(gs1Data.date).format('DD/MM/YYYY'));
      }
      
      // Set the values immediately
      formAdd.setFieldsValue(formValues);
      
       let searchBarcode = cleanBarcode;
      if (gs1Data.gtin) {
        // Use the extracted GTIN (14 digits) to search for the product
        searchBarcode = gs1Data.gtin;
        console.log('Searching product with GTIN:', searchBarcode);
      }

      // Now try to find the product by the full barcode
      let product = null;
      try {
        const response = await ProductApi.GetProductByBarcode(searchBarcode, ProductDetails?.supplierDTO?.supplierName);
        product = response?.payload;
      } catch (error) {
        console.log('Product not found with full barcode');
      }

      if (product) {
        setProducts(prevProducts => {
         const filteredProducts = prevProducts.filter(p => p.id !== product.id);
          return [product, ...filteredProducts];
        });

        // Set the selected product
        setSelectPro(product);

        // Set all form values including storageId
        formAdd.setFieldsValue({
          productId: product.id,
          unit: product?.unitUomOne,
          institutionId: product?.institutionDTO?.id,
          Allergen: product?.allergens?.map(item => item.id) || [],
          storageId: product?.storageDTO?.id || undefined,
          ...formValues
        });

        // Force a re-render to update the Select display
        setTimeout(() => {
          // Re-set the productId to ensure the Select component displays properly
          formAdd.setFieldsValue({
            productId: product.id
          });

          const storageIdValue = formAdd.getFieldValue('storageId');

          // If storageId is not set properly, try again
          if (!storageIdValue && product?.storageDTO?.id) {
            formAdd.setFieldsValue({
              storageId: product.storageDTO.id
            });
          }

          // Trigger validation to update UI
          formAdd.validateFields(['productId']).catch(() => { });
        }, 200);

        setBarcodeError(null);
        setBarcodeScanning(false);
        return;
      }
      else {
        setBarcodeError('No product found for this barcode. Please select product manually.');
        setBarcodeScanning(false);
        return;
      }
    }
         // If not GS1 barcode, try regular barcode search
    let response;
    let product;

    try {
      response = await ProductApi.GetProductByBarcode(cleanBarcode, ProductDetails?.supplierDTO?.supplierName);
      product = response?.payload;
    } catch (error) {
      console.log('Product not found with full barcode');
    }

    if (product) {
      // Product found with regular barcode
      setProducts(prevProducts => {
        const filteredProducts = prevProducts.filter(p => p.id !== product.id);
        return [product, ...filteredProducts];
      });

      setSelectPro(product);

      formAdd.setFieldsValue({
        productId: product.id,
        unit: product?.unitUomOne,
        institutionId: product?.institutionDTO?.id,
        Allergen: product?.allergens?.map(item => item.id) || [],
        storageId: product?.storageDTO?.id || undefined,
      });

      setTimeout(() => {
        formAdd.setFieldsValue({
          productId: product.id
        });

        const storageIdValue = formAdd.getFieldValue('storageId');
        if (!storageIdValue && product?.storageDTO?.id) {
          formAdd.setFieldsValue({
            storageId: product.storageDTO.id
          });
        }

        formAdd.validateFields(['productId']).catch(() => { });
      }, 200);

      setBarcodeError(null);
      setBarcodeScanning(false);
      return;
    } else {
      setBarcodeError('No product found for this barcode');
    }
    } 
    catch (error) {
      console.error('Barcode scan error:', error);
      const apiError = error?.apiError?.message ||
        error?.response?.data?.apiError?.message ||
        error?.response?.data?.message ||
        "Failed to fetch product details. Please try again.";
      setBarcodeError(apiError);
    } finally {
      setBarcodeScanning(false);
    }
  };

  // Set initial form values from ProductDetails
  React.useEffect(() => {
    if (ProductDetails && visible) {
      formAdd.setFieldsValue({
        invoiceNumber: ProductDetails?.deliveryDocketNumber,
        supplierId: ProductDetails?.supplierDTO?.id,
        unit: ProductDetails?.productDTO?.unit,
        storageId: ProductDetails?.storageDTO?.id,
      });
    }
  }, [ProductDetails, visible, formAdd]);

  return (
    <>
      <Modal
        footer={[]}
        width={600}
        open={visible}
        maskClosable={false}
        onCancel={handleCancel}
        onOk={onClose}
      >
        <Title level={4} className="text-center Primary-Font mb-4 pb-3">
          Add Stock
        </Title>
        <Form
          form={formAdd}
          name="nest-messages"
          layout="horizontal"
          labelCol={{
            span: 9,
          }}
          wrapperCol={{
            span: 15,
          }}
          className="FormClass IndividualProduct-Model"
          onFinish={handleSubmit}
        >
          <>
           <Form.Item
            name="barcode"
            label="Barcode"
            className="text-lable pt-1"
          >
            <Input
                    ref={inputRef}
              type="text"
              placeholder="Scan or enter barcode"
              className="control-input"
              suffix={
                    <>
                      {barcodeType === 'gs1' && (
                        <span style={{ fontSize: '10px', color: '#1890ff', marginRight: '5px' }}>
                          GS1
                        </span>
                      )}
                      {barcodeScanning && <LoadingOutlined />}
                    </>
                  }
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === "Tab") {
                  e.preventDefault();

                  const barcode = e.target.value?.trim();

                  if (barcode) {
                    handleBarcodeScan(barcode);
                  }
                }
              }}
              onBlur={(e) => {
                // scanner sometimes triggers blur instead of enter
                const barcode = e.target.value?.trim();

                if (barcode && !SelectPro) {
                  handleBarcodeScan(barcode);
                }
              }}
              onChange={(e) => {
                  setBarcodeType(null);
                }}
            />
          </Form.Item>

            <Form.Item
              name=""
              label=" "
              colon={false}
              className="text-lable"
              style={{ color: "white" }}
            >
              <Alert
                message="Please scan the barcode to continue"
                type="info"
                className="temp-info-text"
              />
              <br />
            </Form.Item>

            {barcodeError && (
              <Form.Item label=" " className="text-lable">
                <Alert
                  message={barcodeError}
                  type="error"
                  className="temp-error-text"
                  showIcon
                />
                <br />
              </Form.Item>
            )}

            <div className="Ingrefiant-form">

           {gtin && (
              <Form.Item
                name="gtin"
                label="GTIN"
                className="text-lable pt-1"
                rules={[
                  {
                    required: true,
                    message: "Please enter GTIN.",
                  },
                ]}
              >
                <Input
                  type="text"
                  placeholder="GTIN"
                  className="control-input"
                />
              </Form.Item>
            )}

              <Form.Item
                name="productId"
                label="Product Name :"
                className="text-lable disabled"
                rules={[
                  {
                    required: true,
                    message: "Please enter Product Name.",
                  },
                ]}
              >
                <Select
                  showSearch
                  className="select-multi"
                  onPopupScroll={handleScroll}
                  placeholder="Select Product Name"
                  filterOption={(input, option) =>
                    (option?.props?.children || '').toLowerCase().includes(input.toLowerCase())
                  }
                  onChange={(value) => handleChangeProduct(value)}
                  optionLabelProp="label"
                  loading={loading}
                  notFoundContent={loading ? <Spin size="small" /> : "No products found"}
                  style={{
                    border: 'none',
                  }}
                >
                  {Products
                    ?.filter(product =>
                      product?.supplierDTO?.some(
                        s => s.id === ProductDetails?.supplierId
                      )
                    )
                    .map(product => (
                      <Select.Option
                        key={product.id}
                        value={product.id}
                        label={product.productName}
                      >
                        {product.productName}
                      </Select.Option>
                    ))
                  }
                </Select>
              </Form.Item>
            </div>

            <Form.Item
              name="batchCode"
              label="Batch Code"
              className="text-lable disabled pt-2"
              rules={[
                {
                  required: false,
                  message: "Please enter Batch Code.",
                },
              ]}
            >
              <Input
                type="text"
                placeholder="Batch Code"
                className="control-input speachBtn mb-0"
                style={{
                  border: 'none',
                }}
                addonAfter={
                  <Button
                    onMouseDown={() => startRecording('batchCode')}
                    onMouseUp={stopRecording}
                    onMouseLeave={stopRecording}
                    style={{
                      border: 'none',
                      padding: 0,
                      margin: 0,
                      background: 'none',
                      cursor: 'pointer',
                    }}
                  >
                    {isRecordingproductCode ? <LoadingOutlined /> : <AudioOutlined />}
                  </Button>
                }
              />
            </Form.Item>

            <Form.Item
              name="invoiceNumber"
              label="Invoice Number"
              className="text-lable disabled pt-1"
              rules={[
                {
                  required: true,
                  message: "Please enter Invoice Number.",
                },
              ]}
            >
              <Input
                type="text"
                disabled
                placeholder="Invoice Number"
                className="control-input"
              />
            </Form.Item>

            <div className="row product-row d-flex ">
              <div className="col-2 StockCol"></div>
              <div className="col-4">
                <Form.Item
                  name="unitOfMeasurement1"
                  label="UoM 1"
                  className="text-lable"
                  style={{ width: '100%' }}
                  rules={[]}
                >
                 <Input
                    type="text"
                    placeholder= "UoM 1"
                    inputMode="decimal"
                    style={{ 
                      textAlign: 'center',
                      MozAppearance: 'textfield'
                    }}
                    onKeyDown={(e) => {
                      const key = e.key;
                      const currentValue = e.target.value;
                      
                      // Allow control keys
                      const controlKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 
                                          'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
                                          'Home', 'End'];
                      
                      if (controlKeys.includes(key)) {
                        return;
                      }
                      
                      // Allow numbers
                      if (/^[0-9]$/.test(key)) {
                        return;
                      }
                      
                      // Allow single decimal point
                      if (key === '.' && !currentValue.includes('.')) {
                        return;
                      }
                      
                      // Prevent everything else
                      e.preventDefault();
                    }}
                    onChange={(e) => {
                      const value = e.target.value;

                      // Only allow numbers and a single decimal point
                      if (value === '' || /^\d*\.?\d*$/.test(value)) {
                        formAdd.setFieldsValue({
                          unitOfMeasurement1: value
                        });

                      const integerPart = value.split('.')[0];

                        if (integerPart.length > 2) {
                          notification.warning({
                            message: 'Please check the value',
                            description: 'Are you sure this is correct? The value has more than 2 digits.',
                            placement: 'topRight'
                          });
                        }
                      }
                    }}
                    className="control-input"
                  />
                </Form.Item>
              </div>
              <div className="col-5 pr-0" style={{ display: 'flex', alignItems: 'center' }}>
                <p style={{ fontSize: '18px' }}> {SelectPro?.unitUomOne || 'Unit'}</p>
              </div>
            </div>

            <div className="row product-row d-flex ">
              <div className="col-2 StockCol"></div>
              <div className="col-4">
                <Form.Item
                  name="unitOfMeasurement2"
                  label="UoM 2"
                  className="text-lable"
                >
                    <Input
                      type="text"
                      placeholder= "UoM 2"
                      inputMode="decimal"
                      style={{ 
                        textAlign: 'center',
                        MozAppearance: 'textfield'
                      }}
                      onKeyDown={(e) => {
                        const key = e.key;
                        const currentValue = e.target.value;
                        
                        // Allow control keys
                        const controlKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 
                                            'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
                                            'Home', 'End'];
                        
                        if (controlKeys.includes(key)) {
                          return;
                        }
                        
                        // Allow numbers
                        if (/^[0-9]$/.test(key)) {
                          return;
                        }
                        
                        // Allow single decimal point
                        if (key === '.' && !currentValue.includes('.')) {
                          return;
                        }
                        
                        // Prevent everything else
                        e.preventDefault();
                      }}
                     onChange={(e) => {
                      const value = e.target.value;

                      if (value === '' || /^\d*\.?\d*$/.test(value)) {
                        formAdd.setFieldsValue({
                          unitOfMeasurement2: value
                        });

                        const integerPart = value.split('.')[0];

                        if (integerPart.length > 2) {
                          notification.warning({
                            message: 'Please check the value',
                            description: 'Are you sure this is correct? The value has more than 2 digits.',
                            placement: 'topRight'
                          });
                        }
                      }
                    }}
                      className="control-input"
                    />
                </Form.Item>
              </div>
              <div className="col-5 pr-0" style={{ display: 'flex', alignItems: 'center' }}>
                <p style={{ fontSize: '18px' }}> {SelectPro?.unitUomTwo || 'Unit'}</p>
              </div>
            </div>

            <Form.Item
              name="OUBD"
              label={
                <div>
                  <p className="mb-0 pb-0" style={{ color: 'gray', fontSize: '12px' }}>
                    <p className="mb-0 pb-0" style={{ color: 'black', fontSize: '15px' }}>
                      OUBD
                    </p>
                    (Original Used by Date)
                  </p>
                </div>
              }
              className="text-lable"
            
              rules={[
                {
                  validator: (_, value) => {
                    if (!value || value === undefined || value === null) {
                      return Promise.reject("Please select OUBD.");
                    }
                    const date = dayjs(value);
                    if (!date.isValid()) {
                      return Promise.reject("Please enter a valid date.");
                    }
                    return Promise.resolve();
                  }
                }
              ]}
            >
              <DateInputMask disabledDate={disableDate} />
            </Form.Item>

            <AllergenStock product={SelectPro} />

            <Form.Item
              name="storageId"
              label="Storage"
              className="text-lable"
              rules={[
                {
                  required: true,
                  message: "Please select storage.",
                },
              ]}
            >
              <Select
                placeholder="Select storage location"
                loading={storagesLoading}
                allowClear
                showSearch
                filterOption={(input, option) =>
                  (option?.props?.children || '').toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {storages
                  .filter(
                    (option) =>
                      !(option.temperatureMinInCelsius === 0 &&
                        option.temperatureMaxInCelsius === 0)
                  )
                  .map((option) => (
                    <Select.Option key={option.id} value={option.id}>
                      {option.name} ({option.temperatureMinInCelsius} - {option.temperatureMaxInCelsius} °C)
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>

            <div className="d-flex justify-content-center pt-4">
              <Button
                type="primary"
                htmlType="submit"
                className="btn btn-primary btn-save mx-2"
                style={{ width: "37%" }}
                disabled={!SelectPro}
              >
                Add Stock
              </Button>
              <Link
                type="primary"
                to={""}
                className="btn btn-primary btn-back mx-2 w-20"
                style={{ width: "37%" }}
                onClick={handleContinue}
                disabled={!SelectPro}
              >
                Continue
              </Link>
            </div>
          </>
        </Form>
      </Modal>

      <Modal
        open={isModalproduct}
        width={1000}
        onOk={handleOk}
        onCancel={handleCancelProduct}
        footer={[]}
        maskClosable={false}
      >
        <div className="product-model text-center">
          <Title level={4} className="Primary-Font ">
            OCR SCAN
          </Title>
        </div>
        <div className="product-OCR-model pt-3">
          <Row gutter={24}>
            <Col span={10}>
              <div className="d-flex justify-content-center pb-2">
                {isCameraOn && (
                  <CameraTwoTone className="OCR-icon px-4" onClick={CameraOn} />
                )}
                {!isCameraOn && (
                  <CameraOutlined
                    className="OCR-icon px-4"
                    onClick={CameraOn}
                  />
                )}
                <label htmlFor="UploadImage">
                  {src && (
                    <PictureTwoTone
                      className="OCR-icon px-4"
                      style={{ cursor: "pointer" }}
                    />
                  )}
                  {!src && (
                    <PictureOutlined
                      className="OCR-icon px-4"
                      style={{ cursor: "pointer" }}
                    />
                  )}
                </label>
              </div>
              {isCameraOn && (
                <>
                  <p className="text-center pt-2">Preview</p>
                  <Webcam
                    audio={false}
                    ref={webcamRef}
                    style={{ width: "100%" }}
                    screenshotFormat="image/jpeg"
                    videoConstraints={{ facingMode: "environment" }}
                  />
                  <div className="d-flex justify-content-center">
                    <Button
                      type="button"
                      onClick={captureImage}
                      className="btn btn-primary btn-save mx-0"
                      disabled={loadings}
                    >
                      Take a photo{loadings && <Spin className="px-2 pt-2" />}
                    </Button>
                  </div>
                </>
              )}
              {src && (
                <>
                  <p className="text-center pt-2">Preview Area</p>
                  <div className="d-flex justify-content-center pb-5">
                    <ZoomOutOutlined onClick={handleZoomOut} />
                    <ZoomInOutlined
                      onClick={handleZoomIn}
                      style={{ paddingRight: "10px" }}
                    />
                    <RotateLeftOutlined onClick={handleRotate} />
                    <RotateRightOutlined onClick={handleRightRotate} />
                  </div>
                  <Cropper
                    ref={cropperRef}
                    src={src}
                    zoomTo={zoom}
                    style={{
                      width: "100%",
                      height: "300px",
                      transform: `rotate(${rotation}deg)`,
                    }}
                  />
                  <br />
                  <div className="d-flex justify-content-center">
                    <Button
                      type="button"
                      onClick={performOCR}
                      className="btn btn-primary btn-save mx-0"
                      disabled={loadings}
                    >
                      Scan {loadings && <Spin className="px-2 pt-2" />}
                    </Button>
                  </div>
                </>
              )}
              <input
                type="file"
                accept="image/*"
                id="UploadImage"
                style={{ visibility: "hidden" }}
                onChange={onSelectFile}
              />
            </Col>
            <Col span={6}>
              <Button
                type="button"
                style={{ height: "auto" }}
                className={`btn btn-primary ${selectedOption === "PName" ? "btn-save" : "btn-back"} mx-0`}
                disabled={selectedOption === "PName"}
                onClick={() => setSelectedOption("PName")}
              >
                Product Name
              </Button>
              <Button
                type="button"
                style={{ height: "auto" }}
                className={`btn btn-primary ${selectedOption === "BarCode" ? "btn-save" : "btn-back"} mx-0`}
                disabled={selectedOption === "BarCode"}
                onClick={() => setSelectedOption("BarCode")}
              >
                Barcode
              </Button>
              <Button
                type="button"
                style={{ height: "auto" }}
                className={`btn btn-primary ${selectedOption === "OUBD" ? "btn-save" : "btn-back"} mx-0`}
                disabled={selectedOption === "OUBD"}
                onClick={() => setSelectedOption("OUBD")}
              >
                OUBD
              </Button>
            </Col>
            <Col span={8}>
              <Form
                form={form}
                name="nest-messages"
                className="FormClass IndividualProduct-Model"
                labelCol={{
                  span: 24,
                }}
                wrapperCol={{
                  span: 24,
                }}
                onFinish={SaveAddForm}
              >
                <Form.Item
                  name="ProductName"
                  label="Product Name"
                  className="text-lable"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Product Name.",
                    },
                  ]}
                >
                  <Input
                    type="text"
                    placeholder="Captured Product Name"
                    className="control-input"
                  />
                </Form.Item>
                <Form.Item
                  name="BarCode"
                  label="BarCode"
                  className="text-lable"
                  rules={[
                    {
                      required: true,
                      message: "Please enter BarCode.",
                    },
                  ]}
                >
                  <Input
                    type="text"
                    placeholder="Captured barcode"
                    className="control-input"
                  />
                </Form.Item>
                <Form.Item
                  name="OCROUBD"
                  label="OUBD"
                  className="text-lable"
                >
                  <DatePicker
                    format={"DD/MM/YYYY"}
                    placeholder="Select OUBD"
                    className="form-control control-input"
                  />
                </Form.Item>
                <div className="d-flex justify-content-center">
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="btn btn-primary btn-save mx-0"
                  >
                    Submit
                  </Button>
                </div>
              </Form>
            </Col>
          </Row>
        </div>
      </Modal>
    </>
  );
}

export default AddStock;